import React from "react";
import WebPageTopics from "../../../topics/WebPageTopics";


function ChapterWiseWeightageChemTopics() {

  
  return (
    <>

      <WebPageTopics subject="chemistry" type="chapterwiseweightage" />


    </>
  );
}

export default ChapterWiseWeightageChemTopics;